export enum Materiel {
    Surber = 1,
    Haveneau,
    DragueTriangulaire,
    DragueCylindrique
}
